import { EXAMPLE_PROMPTS } from '../data/tools';

export function Prompts() {
    return (
        <section className="tkh-section tkh-prompts" aria-labelledby="prompts-title" data-reveal>
            <div className="tkh-wrap">
                <p className="tkh-eyebrow">Say it like a passenger</p>
                <h2 id="prompts-title" className="tkh-h2">
                    No flight codes required.
                </h2>
                <p className="tkh-lede">Each of these turns into a tool call the server handles end to end. The tool it lands on is shown underneath.</p>
                <div className="tkh-stubs">
                    {EXAMPLE_PROMPTS.map((p, i) => (
                        <div className="tkh-stub" key={p.prompt} style={{ '--i': i } as React.CSSProperties}>
                            <q>{p.prompt}</q>
                            <div className="tool">
                                → <b>{p.tool}</b>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
